import { updateFrequency, getPriceByQuoteParameters } from "./joinFlow/services";

function showLoading(){
  const whiteLoadingContainerElems = document.querySelectorAll(".js-price-loading-container-white");
  whiteLoadingContainerElems.forEach(containerElem => {
    containerElem.classList.add("loading-white");
  });  

  const orangeLoadingContainerElems = document.querySelectorAll(".js-price-loading-container-orange");
  orangeLoadingContainerElems.forEach(containerElem => {
    containerElem.classList.add("loading-orange");
  });  
}

function hideLoading(){
  const container = document.querySelectorAll(".loading-white,.loading-orange");
  container.forEach(containerElem => {
    containerElem.classList.remove("loading-white");
    containerElem.classList.remove("loading-orange");
  });  
}

function updatePriceDisplay(response){
  const priceTotalElements = document.querySelectorAll(".js-price-total");
  priceTotalElements.forEach(priceElem => {
    priceElem.innerHTML = response.premiumFormatted;
  });
}

function updateOldestAge(response){
  const oldestAgeLabelElements = document.querySelectorAll(".js-oldest-age");
  if(oldestAgeLabelElements){
    oldestAgeLabelElements.forEach(elem=>{
      elem.innerHTML = response.oldestAge;
    });
  }
}

function updateRebate(response){
  const rebateLabelElements = document.querySelectorAll(".js-rebate");
  const rebateTextElements = document.querySelectorAll(".js-rebate-verbiage");
  if(rebateLabelElements){
    rebateLabelElements.forEach(elem=>{
      elem.innerHTML = response.rebatePercentage + '%';
    });
  }

  if(rebateTextElements){
    rebateTextElements.forEach(elem=>{
      elem.innerHTML = response.rebateText;
    });
  }
}

function updateAgeBasedDiscount(response){
  const ageBaseLabelElements = document.querySelectorAll(".js-age-based");
  if(ageBaseLabelElements){
    ageBaseLabelElements.forEach(elem=>{
      const labelElem = elem.querySelector(".js-age-based-label");
      if(response.combinedAgeDiscountPercent > 0){
        elem.style.display = 'block'
        labelElem.innerHTML = response.combinedAgeDiscountPercent + '%';
      }
      else{
        elem.style.display = 'none';
      }
      
    });
  }
}

function updateLhc(response){
  const lhcLabelElements = document.querySelectorAll(".js-lhc");
  if(lhcLabelElements){
    lhcLabelElements.forEach(elem=>{
      elem.innerHTML = response.lhcLoadingPercent + '%';
    });
  }
}

let getPriceTimeout;
function updatePriceByQuoteParameters(callback: any = null){

  showLoading();

  // Clears timeout every time update price has been triggered
  clearTimeout(getPriceTimeout);

  // Initialize new interval
  getPriceTimeout = setTimeout(()=> {    
    getPriceByQuoteParameters(window.Westfund.QuoteParameters)
      .then((response)=>{
        updatePriceDisplay(response);
        updateRebate(response);
        hideLoading();
        if(callback){
          callback(response);
        }        
      });   
  }, 1000);
  
}

function updateFrequencyLabelDisplay(frequency){
  const frequencyLabelElements = document.querySelectorAll(".js-frequency-label");
  const frequencyPerLabelElements = document.querySelectorAll(".js-frequency-per-label");

  // Update the frequency label
  frequencyLabelElements.forEach(labelElem => {
    labelElem.innerHTML = frequency;
  });

  // Update the frequency per label on the stick container
  frequencyPerLabelElements.forEach(labelElem => {
    labelElem.innerHTML = window.Westfund.FrequencyLabels[frequency];
  });
  
}

function updatePriceChangeMessageByClassName(response, className){
  const msgElems = document.querySelectorAll(`.${className}`); 
  updatePriceChangeMessageByElement(response, msgElems);
}

function updatePriceChangeMessageByElement(response, msgElems){
    msgElems.forEach(elem=>{     
      if(response.premiumFormatted !== window.Westfund.OriginalPrice){
        elem.classList.remove('hidden');
      }  
    });

    // Updates all the price instances
    document.querySelectorAll(".js-price-change-amount").forEach(elem=> {
      elem.innerHTML = response.premiumFormatted;
    });
}

const initFrequencyChange = () =>{

  const frequencyOptions = document.querySelectorAll<HTMLButtonElement>('.js-frequency');
  const priceTotalElements = document.querySelectorAll(".js-price-total");
  const dropdowns = document.querySelectorAll("#join-header-dropdown, #large-header-dropdown");
  

  frequencyOptions?.forEach(elem => {
    elem.addEventListener("click", function(e){
      const frequency = elem.previousElementSibling?.value;

      dropdowns?.forEach(dropdownElem => {
        dropdownElem.removeAttribute("open");
      });
      
      if(frequency === window.Westfund.QuoteParameters.Frequency)
        return;

      showLoading();

      updateFrequency(frequency).then(function(response){

        // Update the total price
        priceTotalElements.forEach(priceElem => {
          priceElem.innerHTML = response.premiumFormatted;
        });

        hideLoading();
        
        updateFrequencyLabelDisplay(frequency);

        window.Westfund.QuoteParameters.Frequency = frequency;
      });
    });

  });

};


export const getPriceByDateChange = (dob : Date, target) =>{

  const dateString = `${dob.getFullYear()}-${dob.getMonth()+1}-${dob.getDate()}`;
  let shouldUpdateOldestAge = false;
  let priceChangeMsgClassName = '';

  switch(target.dataset.dobGroup){
    case "main":
      window.Westfund.QuoteParameters.MainDob = dateString;
      shouldUpdateOldestAge = true;
      priceChangeMsgClassName = 'js-dob-main-msg';
      break;
    case "partner":
      window.Westfund.QuoteParameters.PartnerDob = dateString;
      shouldUpdateOldestAge = true;
      priceChangeMsgClassName = 'js-dob-partner-msg';
      break;
    case "pay-start":
      window.Westfund.QuoteParameters.StartDate = dateString;
  }

  updatePriceByQuoteParameters((response)=>{
    if(shouldUpdateOldestAge){     
      updateOldestAge(response);
      updateAgeBasedDiscount(response);
      updatePriceChangeMessageByClassName(response, priceChangeMsgClassName);
    }   
  });
 
};

const initStateChange = () =>{

  const stateDropdown = document.getElementById("MainHomeState");  
  if(stateDropdown){
    const stateLabelElements = document.getElementsByClassName("js-state");
    const selectDropdowns = document.querySelectorAll("select[name='State']");

    stateDropdown.addEventListener("change", ()=>{

      window.Westfund.QuoteParameters.State = stateDropdown.value;
      updatePriceByQuoteParameters(response=>{
        updatePriceChangeMessageByClassName(response, 'js-state-msg');
      });


      stateLabelElements.forEach(elem=>{
        elem.innerHTML = stateDropdown.value;
      });

      selectDropdowns.forEach(elem=>{
        elem.value = stateDropdown.value
      });

    });
  }

};

const initRebateChange =()=>{
  const medicareElectronicRebateInputs = document.querySelectorAll<HTMLInputElement>(`[name="MedicareElectronicRebate"]`)
  const rebateTierOptions = document.getElementById("RebateTierId");
  if(medicareElectronicRebateInputs){
    medicareElectronicRebateInputs.forEach((elem)=>{
      elem.addEventListener("change", ()=>{
  
        // TODO: Refactor this? Try using elem.value insted ?
        const medicareElectronicRebateCheckedInput = [...medicareElectronicRebateInputs].filter((el) => el.checked).at(0);
        const isApplyMediCareRebate = (medicareElectronicRebateCheckedInput && medicareElectronicRebateCheckedInput.value === "Y");
   
        window.Westfund.QuoteParameters.ClaimRebate = isApplyMediCareRebate;
        updatePriceByQuoteParameters(response=>{
          updatePriceChangeMessageByClassName(response, 'js-rebate-msg');
        });
      });
    });
  }  

  if(rebateTierOptions){
    rebateTierOptions.addEventListener("change", ()=>{

      const rebate = rebateTierOptions.value;
      window.Westfund.QuoteParameters.GovtRebateTier = rebate;
      updatePriceByQuoteParameters(response=>{
        updatePriceChangeMessageByClassName(response, 'js-income-tier-msg');
      });
    });
  }
};

const initLhcChange = () =>{
  
  /*
    updateCallback - returns a boolean, whether the updatePriceChangeMessageByElement should be triggered
  */
    function addEvent(elements, updateCallback){
      if(elements){
        elements.forEach(elem => {
          
          elem.addEventListener("change", () =>{  
              const shouldTriggerPriceChangeMessage = updateCallback(elem);              
              updatePriceByQuoteParameters((response)=>{
                updateLhc(response);
                if(shouldTriggerPriceChangeMessage){
                  const priceChangeMsgLabelElem = elem.closest('fieldset').querySelectorAll('.js-lhc-msg');
                  updatePriceChangeMessageByElement(response, priceChangeMsgLabelElem);
                }
                
              });
          });
  
        });
      }
    }

    const mainLhc = document.querySelectorAll("[name=HospitalCoverSinceJuly2000]");
    const partnerLhc = document.querySelectorAll("[name=PartnerHospitalCoverSinceJuly2000]");
    const dependantsLhc = document.querySelectorAll(".js-dependants-lhc");

    addEvent(mainLhc, (elem) => {
      const isEmpty =  window.Westfund.QuoteParameters.MainLhc === '';
      window.Westfund.QuoteParameters.MainLhc = elem.value;
      return !(isEmpty && elem.value === 'Y');
    });
   

    addEvent(partnerLhc, (elem) => {
      const isEmpty =  window.Westfund.QuoteParameters.PartnerLhc === '';
      window.Westfund.QuoteParameters.PartnerLhc = elem.value;
      return !(isEmpty && elem.value === 'Y');
    });
   
    addEvent(dependantsLhc, (elem) => {
      const id = elem.dataset.id;
      let isEmpty = false;
      window.Westfund.QuoteParameters.Dependants.forEach(dep=> {
        if(dep.Id === id){
          isEmpty = dep.Lhc === '';
          dep.Lhc = elem.value;
        }
      });

      return !(isEmpty && elem.value == 'Y');
    });
};

const initStartDateChange = () =>{
  const immediateStartOptions = document.querySelectorAll("[name=ImmediateStart]");

  if(immediateStartOptions){
    immediateStartOptions.forEach((elem)=>{
      elem.addEventListener("change", ()=>{
        
        if (elem.value === 'Y'){
          window.Westfund.QuoteParameters.StartDate = null;
          updatePriceByQuoteParameters();                
        }
        else if(elem.value === 'N'){
          const yearElem = document.querySelector("[name=CoverFromDateYear]");
          if(yearElem){
            var inputEvent = new Event('input');
            yearElem.dispatchEvent(inputEvent);
          }
        }
        
      });
    });
  }  
};

// Used on the Payment page
const initPaymentFrequencyChange = ()=> {
  const billingGroupOptions = document.querySelectorAll("[name='DeductionBillingGroupId']");

  if(billingGroupOptions){
    billingGroupOptions.forEach(elem=> {
      elem.addEventListener("change", ()=> {
        const value = elem.value;
        const label = window.Westfund.BillingGroupOptions[value];

        // Get frequency value by getting the first word
        const frequency = label.split(' ')[0];

        // Sets the BillingGroup parameter
        window.Westfund.QuoteParameters.BillingGroupId = value;
        window.Westfund.QuoteParameters.Frequency = frequency;

        updatePriceByQuoteParameters((response) => {
          updateFrequencyLabelDisplay(frequency);
          updatePriceChangeMessageByClassName(response, 'js-frequency-msg');
        });
        
      });
    });
  }
};

const initQuoteStepFrequencyChange = ()=>{

  const forms = document.querySelectorAll(".js-form-frequency, .js-form-excess, .js-form-noextras, .js-form-nohospital");

  if(forms){    
    forms.forEach(form=>{
      form.addEventListener("submit", ()=>{
        document.documentElement.classList.add("loading-with-bg");
        document.documentElement.classList.add("loading-orange");        
      });
    });
  }

};

// Price will change if dependant's LHC is set to NO
export const updatePriceByRemovingNdisDependant = (dependantId) => {

  const originalCount = window.Westfund.QuoteParameters.Dependants.length;

  // Remove the ID if it exist
  window.Westfund.QuoteParameters.Dependants =  window.Westfund.QuoteParameters.Dependants.filter(x=> x.Id !== dependantId);
  
  // Only update the price if dependants count has changed
  if(originalCount !== window.Westfund.QuoteParameters.Dependants.length){
    updatePriceByQuoteParameters();
  }
  
}

export const render = () =>{
    
  initFrequencyChange();
  initStateChange();
  initRebateChange();
  initLhcChange();
  initStartDateChange();
  initPaymentFrequencyChange();
  initQuoteStepFrequencyChange();

};